import axios from "axios";
import { net } from "@/lib/net";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ACCESS = "istoc_access";
const REFRESH = "istoc_refresh";

// Önizleme iframe'inde (3. taraf depolama engelli) localStorage hata fırlatabilir → bellek yedeği
const mem = {};
const store = {
  get: (k) => { try { return localStorage.getItem(k); } catch { return mem[k] ?? null; } },
  set: (k, v) => { try { localStorage.setItem(k, v); } catch { mem[k] = v; } },
  del: (k) => { try { localStorage.removeItem(k); } catch { delete mem[k]; } },
};

export const tokens = {
  access: () => store.get(ACCESS),
  refresh: () => store.get(REFRESH),
  set: (a, r) => {
    if (a) store.set(ACCESS, a);
    if (r) store.set(REFRESH, r);
  },
  clear: () => {
    store.del(ACCESS);
    store.del(REFRESH);
  },
};

const SHOW_TEST = "istoc_show_test";
export const showTest = { get: () => store.get(SHOW_TEST) === "1", set: (on) => (on ? store.set(SHOW_TEST, "1") : store.del(SHOW_TEST)) };

export const api = axios.create({ baseURL: BASE, timeout: 30000 });

api.interceptors.request.use((cfg) => {
  const write = !["get", "head", "options"].includes((cfg.method || "get").toLowerCase());
  if (write && net.blocked() && !(cfg.url || "").startsWith("/auth/")) {
    return Promise.reject(Object.assign(new Error("Bağlantı yok — işlem gönderilmedi. Bağlantı gelince tekrar deneyin."), { offlineBlocked: true }));
  }
  const t = tokens.access();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  cfg.headers["X-Client-Platform"] = "web";
  if (!write && showTest.get()) cfg.params = { ...(cfg.params || {}), include_test: true };
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => { net.ok(); return r; },
  async (error) => {
    if (error.offlineBlocked) return Promise.reject(error);
    if (error.response) net.ok(); else net.fail();
    const original = error.config || {};
    const isAuthCall = (original.url || "").startsWith("/auth/login") || (original.url || "").startsWith("/auth/refresh");
    if (error.response?.status === 401 && !original._retry && tokens.refresh() && !isAuthCall) {
      original._retry = true;
      try {
        refreshing = refreshing || axios.post(`${BASE}/auth/refresh`, { refresh_token: tokens.refresh() }).finally(() => { refreshing = null; });
        const { data } = await refreshing;
        tokens.set(data.access_token, data.refresh_token);
        original.headers.Authorization = `Bearer ${data.access_token}`;
        return api(original);
      } catch (e) {
        tokens.clear();
        window.dispatchEvent(new Event("auth:logout"));
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e, fallback = "Bir hata oluştu. Lütfen tekrar deneyin.") {
  const detail = e?.response?.data?.detail;
  if (e?.code === "ECONNABORTED") return "Sunucu zamanında yanıt vermedi. Bağlantınızı kontrol edip tekrar deneyin.";
  if (e && !e.response && e.request) return "Sunucuya ulaşılamadı. İnternet bağlantınızı kontrol edin.";
  if (detail == null) return e?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
